import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchRoleParams, Role, RoleApiResponse } from "../types/roleTypes";
import {
  createRole,
  deleteRole,
  fetchRoleList,
  updateRole,
} from "../services/roleServices";

interface RoleState {
  roles: Role[];
  loading: boolean;
  error: string | null;
  total: number;
}

const initialState: RoleState = {
  roles: [],
  loading: false,
  error: null,
  total: 0,
};
export const fetchAllRoles = createAsyncThunk<
  RoleApiResponse,
  FetchRoleParams,
  { rejectValue: string }
>("user/fetchAll", async (params, { rejectWithValue }) => {
  try {
    return await fetchRoleList(params);
  } catch (err: any) {
    return rejectWithValue(err.message || "Failed to fetch users");
  }
});
// export const fetchAllRoles = createAsyncThunk<RoleApiResponse>(
//   "role/fetchAll",
//   async (_, thunkAPI) => {
//     try {
//       const res = await fetchRoleList();
//       return res;
//     } catch (err: any) {
//       return thunkAPI.rejectWithValue(err?.message || "Failed to fetch roles");
//     }
//   }
// );

export const createNewRole = createAsyncThunk<
  RoleApiResponse,
  {
    role_name: string;
    display_name: string;
    permission_ids: number[];
  },
  { rejectValue: string }
>("role/create", async (payload, thunkAPI) => {
  try {
    const res = await createRole(payload);
    return res;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error || "Role creation failed");
  }
});

export const deleteRoleById = createAsyncThunk<
  RoleApiResponse,
  number,
  { rejectValue: string }
>("role/delete", async (id, { rejectWithValue }) => {
  try {
    return await deleteRole(id);
  } catch (err: any) {
    return rejectWithValue(err.message || "Failed to delete user");
  }
});

export const updateRoleById = createAsyncThunk<
  RoleApiResponse,
  { id: number; formData: FormData },
  { rejectValue: string }
>("user/update", async ({ id, formData }, { rejectWithValue }) => {
  try {
    const res = await updateRole(id, formData); // ⬅️ From your service
    return res;
  } catch (err: any) {
    return rejectWithValue(err.message || "Failed to update user");
  }
});
const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllRoles.fulfilled, (state, action) => {
        state.roles = action.payload.data.data; // ✅ Only assign array to roles
        state.loading = false;
        state.total = action.payload.data.total;
      })
      .addCase(fetchAllRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(createNewRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewRole.fulfilled, (state, action) => {
        state.roles = action.payload.data.data; // or push if you don't want to replace all
        state.loading = false;
      })
      .addCase(createNewRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create role";
      })

      //delete role
      .addCase(deleteRoleById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteRoleById.fulfilled, (state, action) => {
        const deletedId = action.meta.arg; // The ID passed into the thunk
        state.roles = state.roles.filter((role) => role.id !== deletedId);
        state.total = Math.max(0, state.total - 1); // prevent going below 0
        state.loading = false;
      })
      .addCase(deleteRoleById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to Delete role";
      })

      //update Role
      .addCase(updateRoleById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRoleById.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload.data.data;
      })

      .addCase(updateRoleById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update role";
      });
  },
});

export default roleSlice.reducer;
